/** Shared number formatting for Bandwidth dashboard UI and exports (2 decimal places). */

const BW_DECIMAL_OPTS = { minimumFractionDigits: 2, maximumFractionDigits: 2 } as const;

export function roundBwDecimal(n: number): number {
  return Math.round(n * 100) / 100;
}

export function fmtBwDecimal(n: number): string {
  return n.toLocaleString(undefined, BW_DECIMAL_OPTS);
}

export function fmtBwAvg(n: number | null | undefined): string {
  if (n == null) return '—';
  return fmtBwDecimal(n);
}

export function fmtBwPercent(n: number | null | undefined): string {
  if (n == null) return '—';
  return `${fmtBwDecimal(n)}%`;
}

/** Whole-number activity counts (not fractional). */
export function fmtBwCount(n: number): string {
  return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

/** Whole-number minutes — no decimal places in UI or exports. */
export function roundBwMinutes(n: number): number {
  return Math.round(n);
}

export function fmtBwMinutes(n: number): string {
  return fmtBwCount(n);
}

/** Excel/PDF minute columns — empty string when null/undefined. */
export function bwExportMinutes(n: number | null | undefined): number | '' {
  if (n == null) return '';
  return roundBwMinutes(n);
}

/** Excel numeric cells — empty string when null/undefined. */
export function bwExportDecimal(n: number | null | undefined): number | '' {
  if (n == null) return '';
  return roundBwDecimal(n);
}

/** Excel percent columns — empty string when null/undefined. */
export function bwExportPercent(n: number | null | undefined): number | '' {
  if (n == null) return '';
  return roundBwDecimal(n);
}

/** PDF percent columns — empty string when null/undefined. */
export function bwExportPercentPdf(n: number | null | undefined): string {
  if (n == null) return '';
  return `${fmtBwDecimal(n)}%`;
}
